import React from "react";
import { Switch, Route } from "react-router-dom";
import Welcome from "./_pages/_welcome/welcome";
import SelectFindingRule from "./_pages/_selectFindingRule/SelectFindingRule.js";
import CreateFindingRule from "./_pages/_selectFindingRule/CreateFindingRule";
import ScopedFindingRuleConfiguration from "./_pages/scopedFindingRule/ScopedFindingRuleConfiguration.jsx";
import recommendationList from "./_pages/recommendationList/recommendationList.jsx";
import SelectScope from "./_pages/selectScope/SelectScope.jsx";
import ScopedAnomalyRuleConfiguration from "./_pages/anomalyRule/ScopedAnomalyRuleConfiguration";
import SelectScopedAnomalyRule from "./_pages/anomalyRule/SelectScopedAnomalyRule";
import SelectAnomalyRule from "./_pages/anomalyRule/SelectAnomalyRule";
import Landing from "./_pages/_landing/landing";
import SelectRecommendation from "./_pages/recommendationWorkflow/SelectRecommendation";
import ProtectedRoute from "./ProtectedRoute.js";

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/" component={Welcome} />
      <ProtectedRoute exact path="/rules" component={Landing} />
      <ProtectedRoute
        path="/rules/select_finding_rule/select_scope/scoped_finding_rule_configuration"
        component={ScopedFindingRuleConfiguration}
      />
      <ProtectedRoute
        exact
        path="/rules/select_finding_rule/create_finding_rule"
        component={CreateFindingRule}
      />
      <ProtectedRoute exact path="/recommendationList" component={recommendationList} />
      <ProtectedRoute exact path="/rules/select_anomaly_rule" component={SelectAnomalyRule} />

      {/* <Route component={Page404} /> */}
      <ProtectedRoute exact 
        path="/rules/select_finding_rule" 
        component={SelectFindingRule} 
      />
      <ProtectedRoute exact path="/rules/select_finding_rule/select_scope" component={SelectScope} />
      <ProtectedRoute
        exact
        path="/rules/select_anomaly_rule/select_scoped_anomaly_rule/scoped_anomaly_rule_configuration"
        component={ScopedAnomalyRuleConfiguration}
      />
      <ProtectedRoute
        path="/rules/select_anomaly_rule/select_scoped_anomaly_rule"
        component={SelectScopedAnomalyRule}
        exact
      />
      <ProtectedRoute path="/rules/select_recommendation" component={SelectRecommendation} />
    </Switch>
  );
};

export default Routes;
